import { Button, Text, Link, Image } from "@fluentui/react-components";
import {
  ArrowCounterclockwiseFilled,
  ArrowRightFilled,
  MailArrowUpRegular,
  MailCheckmarkRegular,
  PersonKeyFilled,
} from "@fluentui/react-icons";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { useNavigate } from "react-router-dom";
import useWindowSize from "../../../helpers/useWindowSize";
import { ReactElement, ReactNode, useState } from "react";
import i18n from "i18next";
import "./home.css";

interface IHomeTeaserProps {
  modulName: string;
  name: string;
  mainImgUrl: string;
  secondImgUrl?: string;
  thirdImgUrl?: string;
  targetUrl: string;
  isLoggedIn: boolean;
  hasRole: boolean | undefined;
  forceDisable: boolean;
  hasRequested: boolean | undefined;
  roleRequested: any;
  filledIcon: ReactElement;
  regularIcon: ReactElement;
}

export default function HomeCard(props: IHomeTeaserProps) {
  const navigate = useNavigate();
  const windowSize = useWindowSize();
  const [onHover, setOnHover] = useState(false);

  const onClick = () => {
    if (props.isLoggedIn && props.hasRole) {
      navigate(props.targetUrl);
    } else if (props.isLoggedIn && !props.hasRole) {
      requestRole();
    } else {
      navigate("/account/login?modul=" + props.modulName);
    }
  };

  const requestRole = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/requestrole?role=${props.modulName}`)
      .then(() => {
        props.roleRequested();
      })
      .catch((error) => {});
  };

  let buttonText = "";
  let iconName: any;

  if (props.hasRole == undefined || props.hasRequested == undefined) {
    buttonText = i18n.t<string>("loading");
    iconName = <ArrowCounterclockwiseFilled />;
  } else if (props.hasRole && !props.hasRequested) {
    buttonText = i18n.t<string>("next");
    iconName = <ArrowRightFilled />;
  } else if (!props.hasRole && props.hasRequested) {
    buttonText = i18n.t<string>("requestedRole"); // Angefragt ?
    iconName = <MailCheckmarkRegular />;
  } else if (!props.hasRole && !props.hasRequested) {
    buttonText = i18n.t<string>("requestRole"); // Anfragen ?
    iconName = <MailArrowUpRegular />;
  }

  const disable = () => {
    if (!props.isLoggedIn) {
      return false;
    } else if (props.hasRole == undefined || props.hasRequested == undefined) {
      return true;
    } else if (props.forceDisable) {
      return true;
    } else if (props.hasRequested) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className="card"
      onMouseOver={() => {
        if (onHover == false) {
          setOnHover(true);
        }
      }}
      onMouseLeave={() => {
        if (onHover == true) {
          setOnHover(false);
        }
      }}
    >
      <>
        <div
          onClick={disable() == false ? onClick : () => {}}
          style={{
            marginTop: "15px",
            marginLeft: "10px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {onHover ? props.filledIcon : props.regularIcon}

          <Text
            style={{ marginLeft: "10px", fontSize: "20px" }}
            weight="semibold"
          >
            {props.name}
          </Text>
        </div>
        <div className="modulePreview">
          <div className="turnaround">
            <div
              className="front"
              onClick={disable() == false ? onClick : () => {}}
            >
              <div className="carousel">
                <Image
                  className="imageBox"
                  shape="rounded"
                  src={props.mainImgUrl}
                  alt="Presentation Preview"
                />
                {props.secondImgUrl != undefined && (
                  <Image
                    className="imageBox"
                    shape="rounded"
                    src={props.secondImgUrl}
                    alt="Presentation Preview"
                  />
                )}
                {props.thirdImgUrl != undefined && (
                  <Image
                    className="imageBox"
                    shape="rounded"
                    src={props.thirdImgUrl}
                    alt="Presentation Preview"
                  />
                )}
              </div>
              <div className="textBox">
                {i18n
                  .t<string>(
                    "homeTeaserCardDescription" +
                      props.modulName.toLocaleUpperCase()
                  )
                  .toLocaleUpperCase()}
              </div>
            </div>
            <div className="back">
              <div
                style={{ marginTop: 15 }}
                onClick={disable() == false ? onClick : () => {}}
              >
                <Text weight="bold" size={400}>
                  {i18n.t<string>(
                    "homeTeaserCallOutTitle" + props.modulName.toUpperCase()
                  )}
                </Text>
                <Text block>
                  {i18n.t<string>(
                    "homeTeaserCallOutText" + props.modulName.toUpperCase()
                  )}
                </Text>
              </div>
              <Link
                onClick={() => navigate("/about?module=" + props.modulName)}
              >
                {i18n.t<string>("more")}
              </Link>
            </div>
          </div>
        </div>
      </>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginRight: "10px",
          marginLeft: "10px",
          marginBottom: "15px",
        }}
      >
        <Button
          style={{ minWidth: "130px" }}
          appearance={onHover ? "primary" : "outline"}
          icon={props.isLoggedIn ? iconName : <PersonKeyFilled />}
          disabled={disable()}
          onClick={onClick}
        >
          {props.isLoggedIn ? buttonText : i18n.t<string>("signIn")}
        </Button>
      </div>
    </div>
  );
}
